export const Footer = () => (
  <footer className="main-footer d-flex align-items-center">
    <div className="container-fluid">
      Copyright LincolnStudy © 2024. All rights reserved.
    </div>
  </footer>
);
